import { render, staticRenderFns } from "./checkPerson.vue?vue&type=template&id=03e23a60"
import script from "./checkPerson.vue?vue&type=script&lang=js"
export * from "./checkPerson.vue?vue&type=script&lang=js"
import style0 from "./checkPerson.vue?vue&type=style&index=0&id=03e23a60&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports